import { ApiEndPointsSettings } from 'src/app/applicationModules/settings/common/apiUrls/api-end-points-settings';
import { Injectable, SkipSelf } from '@angular/core';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { EnvService } from 'src/app/env.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AIChatService {
  private baseUrl: any;
  private baseUrlTrans: any;
  private baseUrlRole: any;
  private baseURlOrg: any;
  private baseManageUserUrl: any;
  private isProjectExtended: boolean;
  baseUrlTask: string;
  constructor(
    private _http: HttpClient,
    private apiAddress: ApiEndPointsSettings,
    public env: EnvService,
    private constant: Constants
  ) {
    this.isProjectExtended = false;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrl = this.constant.ManageContactsportNumber;
    else
      this.baseUrl = this.env.apiUrl + this.constant.ManageContactsportNumber;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrlTrans = this.constant.ManageTranscationportNumber;
    else
      this.baseUrlTrans =
        this.env.apiUrl + this.constant.ManageTranscationportNumber;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrlRole = this.constant.RolePortNumber;
    else this.baseUrlRole = this.env.apiUrl + this.constant.RolePortNumber;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseURlOrg = this.constant.ManageOrganizationPortNumber;
    else
      this.baseURlOrg = this.env.apiUrl + this.constant.ManageOrganizationPortNumber;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseManageUserUrl = this.constant.ManageUserPortNumber;
    else
      this.baseManageUserUrl = this.env.apiUrl + this.constant.ManageUserPortNumber;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrlTask = this.constant.ManageTask;
    else
      this.baseUrlTask = this.env.apiUrl + this.constant.ManageTask;
  }
    
  GetResponseFromAI(dataModel) {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetResponseFromAI;
    return this._http.post(apiURL, dataModel).pipe();
  }

  SaveFlowtricesAIMessage(dataModel) {
    const apiURL = this.baseUrlTrans + this.apiAddress.SaveFlowtricesAIMessage;   
    return this._http.post(apiURL, dataModel).pipe();
  }

  GetFlowtricesAIMessage(dataModel) {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetFlowtricesAIMessage;   
    return this._http.post(apiURL, dataModel).pipe();
  }
}
